module.exports = __webpack_public_path__ + "static/media/production-pressurize-02.24d32e06.jpg";